import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';
import { BufferGraphComponent } from 'app/buffer-graph/components/buffer-graph.component/buffer-graph.component';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { ResizeGlyphModule } from 'app/resize-glyph/resize-glyph.module';
import { BufferGraphModalComponent } from 'app/buffer-graph/components/buffer-graph-modal.component/buffer-graph-modal.component';
import { SlickGridModule } from 'app/slick-grid/slick-grid.module';
import { ItemOrderHistoryComponent } from 'app/buffer-graph/components/item-order-history.component/item-order-history.component';
import { BufferChangeHistoryComponent } from 'app/buffer-graph/components/buffer-change-history.component/buffer-change-history.component'
import { ItemActionsComponent } from 'app/buffer-graph/components/item-actions.component/item-actions.component';
import { BufferChangeReasonsComponent } from 'app/buffer-graph/components/buffer-change-reasons.component/buffer-change-reasons.component';
import { SuppliersSchedulesComponent } from 'app/buffer-graph/components/suppliers-schedules.component/suppliers-schedules.component';
import { AssortmentStructureComponent } from 'app/buffer-graph/components/assortment-structure.component/assortment-structure.component';
import { ChangeBufferComponent } from './components/change-buffer.component/change-buffer.component';
import { Amchart4Component } from "./components/amchart4.component/amchart4.component";
import {ChartPeriodSelectorComponent} from "./components/chart-period-selector.component/chart-period-selector.component";
import {BufferGraphDataExchangeService} from "./services/buffer-graph-data-exchange.service";

import {CodeNameListComponent} from "./components/code-name-list.component/code-name-list.component";
import {ChartDataComponent} from "./components/chart-data.component/chart-data.component";
import {TabsListComponent} from "./components/tabs-list.component/tabs-list.component";
import {TabsHeaderComponent} from "./components/tabs-header.component/tabs-header.component";
import {SimpleTabComponent} from "./components/simple-tab.component/simple-tab.component";
import {StocksFilterService} from "../stocks/services/stocks-filter.service";
import {StocksService} from "../stocks/services/stocks.service";
import {ExcelWorkService} from "../services/excel-work.service";
import {ChartInfoComponent} from "./components/chart-info.component/chart-info.component";
import {RouterModule} from "@angular/router";
import {BufferGraphOuterLayerComponent} from "./components/buffer-graph-outer-layer.component/buffer-graph-outer-layer.component";

@NgModule({
    imports: [CommonModule, SharedModule,
        RouterModule.forChild([
            { path: ':id', component: BufferGraphOuterLayerComponent}
        ]),
        TranslateModule.forChild(), ResizeGlyphModule, SlickGridModule, FormsModule],
    declarations: [
        BufferGraphComponent,
        //BufferGraphChartComponent,
        BufferGraphModalComponent,
        ItemOrderHistoryComponent,
        BufferChangeHistoryComponent,
        ItemActionsComponent,
        BufferChangeReasonsComponent,
        SuppliersSchedulesComponent,
        AssortmentStructureComponent,
        ChangeBufferComponent,
        Amchart4Component,
        ChartPeriodSelectorComponent,
        CodeNameListComponent,
        ChartDataComponent,
        TabsListComponent,
        TabsHeaderComponent,
        SimpleTabComponent,
        ChartInfoComponent,
        BufferGraphOuterLayerComponent
    ],
    exports: [
        BufferGraphComponent,
        BufferGraphModalComponent,
        ItemOrderHistoryComponent,
        BufferChangeHistoryComponent,
        ItemActionsComponent,
        BufferChangeReasonsComponent,
        SuppliersSchedulesComponent,
        AssortmentStructureComponent,
        Amchart4Component,
        ChartPeriodSelectorComponent,
        TabsListComponent,
        SimpleTabComponent
    ]
})

export class BufferGraphModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: BufferGraphModule,
            providers: [
                BufferGraphService,
                BufferGraphDataExchangeService,
                StocksFilterService,
                StocksService,
                ExcelWorkService
            ] };
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/buffer-graph.module.ts